export const enClientPortalAssetListPage = {
    emptyStateTitle: 'No assets have been added yet',
    syntheticPortfolioTitle: 'Assets without portfolio',
    closingDateLabel: 'Closing date {{date}}',
}
